<template>
    <div class="wrapper" :class="{ disabled: !actLpoIsDraft }">
        <div>
            <label for="image_date">Дата съемки</label>
            <input type='date' v-model='imageInfo.image_date' id="image_date"/>
        </div>
        <div>
            <label for="aircraft_id">Тип летательного аппарата</label>
            <select v-model="imageInfo.aircraft_id" id="aircraft_id">
                <option  v-for="item in remoteAircraftTypes" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
        </div>
        <div>
            <label for="aircraft_name">Наименование летательного аппарата</label>
            <textarea v-model="imageInfo.aircraft_name" type="text" id="aircraft_name"></textarea>
        </div>
        <div>
            <label for="photo_mode_id">Режим съемки</label>
            <select v-model="imageInfo.photo_mode_id" id="photo_mode_id">
                <option  v-for="item in remoteImageModes" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
        </div>
        <div>
            <label for="sensor_name">Наименование съемочной аппаратуры</label>
            <textarea v-model="imageInfo.sensor_name" type="text" id="sensor_name"></textarea>
        </div>
        <div>
            <label for="spatial_resolution">Пространственное разрешение</label>
            <textarea v-model="imageInfo.spatial_resolution" type="text" id="spatial_resolution"></textarea>
        </div>
        <div>
            <input @click="save(imageInfo)" type="button" value="Сохранить" :disabled="!needToSaveChanges"/>
        </div>
    </div>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  
  const ROOT_API = process.env.VUE_APP_ROOT_API;
  
  const GET_REMOTE_IMAGE_INFO = ROOT_API + 'get_site_data/get_remote_image_info.php';

  import requestToApi from "@/lib/requestToApi";
  export default {
    name: "RemoteImageInfo",
    data() {
      return {
        imageInfoDB: {},
        imageInfo: {},
        addMode: false,
  
        forestry: null,
  
        selectedArea: null,
        selectedSection: null,
        isLpSection: false,
        selectedSectionLp: null,
  
        areaList: [],
        sectionList: [],
  
        selectedList: [],
  
        lpoToRemove: null,
        removeConfirmationOpen: false,
      };
    },
    created() {
      this.updateRemoteImageInfo();
			const catalogs = [ 'info_remote_image_mode', 'info_remote_aircraft_type'];
			this.loadCatalogs(catalogs);
		},
    computed: {
      needToSaveChanges() {
        if (!this.objectsIsDeepEqual(this.imageInfo, this.imageInfoDB)) {
            return true;
        }
        return false;
      },
      actLpoIsDraft() {
        return this.$store.getters["lpoData/actLpoIsDraft"];
      },
      ...mapState("selectedLpo/recount", {
        remoteListRecount: (state) => state.remoteListRecount
      }),
      ...mapState("lpoData", {
        currentLpo: (state) => state.currentLpo,
        actLpoList: (state) => state.actLpoList,
      }),
      ...mapState("selectedLpo", {
        lpo: (state) => state.lpo,
      }),
      ...mapState({
        remoteImageModes: state => state.catalogs.info_remote_image_mode,
        remoteAircraftTypes: state => state.catalogs.info_remote_aircraft_type
		})
    },
    watch: {
      selectedArea(area) {
        if (area) {
          this.getSectionList();
        }
      },
    },
    methods: {
      ...mapActions( ["loadCatalogs"]),
      ...mapActions("selectedLpo/recount", ["setRemoteImageInfo"]),
      async updateRemoteImageInfo() {
        let params = {
            url: GET_REMOTE_IMAGE_INFO,
            params: {lpo_id: this.lpo.lpo_id}
        }
        const data = await requestToApi(params);
        this.imageInfoDB = JSON.parse(JSON.stringify(data));
        this.imageInfo = data;
      },
      async save(imageInfo) {
        const result = await this.setRemoteImageInfo(imageInfo);
        if (result.code == 0) {
          this.updateRemoteImageInfo();
        } else {
          alert("ошибка сохранения: " + result.name)
        }
      },
      objectsIsDeepEqual(object1, object2) {
        const objKeys1 = Object.keys(object1);
        const objKeys2 = Object.keys(object2);

        if (objKeys1.length !== objKeys2.length) return false;

        for (var key of objKeys1) {
          const value1 = object1[key];
          const value2 = object2[key];

          const isObjects = this.isObject(value1) && this.isObject(value2);

          if ((isObjects && !isDeepEqual(value1, value2)) ||
            (!isObjects && value1 !== value2)
          ) {
            return false;
          }
        }
        return true;
        
      },
      isObject(object) {
        return object != null && typeof object === "object";
      },
    }
  };
  </script>
  
  <style scoped src="@/style/wrapper.css"></style>
  <style scoped src="@/style/grid.css"></style>
  <style scoped src="@/style/input.css"></style>
  
  <style scoped>
  
  #aircraft_name {
    min-width: 60%;
 }
 #spatial_resolution {
    min-width: 60%;
 } 
  label { 
    display: block;
    padding-bottom: 4px;
    font-size: 13px;
    font-weight: bold;
  }
  label, input {
    vertical-align: middle;
  }

  .wrapper {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 10px;
    grid-row-gap: 13px;
  }
  .disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  .btn-row {
    margin-bottom: 20px;
  }
  
  .control-btn-row > button {
    margin-right: 10px;
  }
  
  .add-block {
    background-color: #eee;
    padding: 20px 20px;
    border: 1px solid #ccc;
    margin-bottom: 20px;
  }
  
  .add-block-btn-row {
    margin-top: 10px;
  }
  
  .lpos-data {
    padding-top: 30px;
  }
  
  .title-block {
    font-size: 20px;
    font-family: "roboto black";
  
    margin-bottom: 40px;
  }
  
  .lpos-table {
    width: 100%;
    font-size: 14px;
  }
  
  .lpos-table th {
    font-weight: bold;
    padding: 6px;
  }
  
  .lpos-table td {
    border-top: 1px solid #aaa;
    padding: 6px;
    //text-align: center;
    vertical-align: middle;
  }
  </style>